import { createSlice } from "@reduxjs/toolkit";
import {
  createArbitratorDetailsAction,
  updateArbitratorDetailsAction,
  getArbitratorDetailsByCaseIDAction,
  deleteArbitratorDetailsAction,
  arbitratorResendCertificateAction,
  arbitratorEmpanelRenewalStatusAction,
} from "../../actions/ArbitratorDetails/arbitratorDetailsAction";

const initialState = {
  arbitrators: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

const arbitratorDetailsSlice = createSlice({
  name: "arbitratorDetails",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getArbitratorDetailsByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getArbitratorDetailsByCaseIDAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.arbitrators = action.payload.ArbitratorDetails || [];
        },
      )
      .addCase(getArbitratorDetailsByCaseIDAction.rejected, (state, action) => {
        state.loading = false;
        state.arbitrators = action.payload;
      });
    builder
      .addCase(createArbitratorDetailsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createArbitratorDetailsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Arbitrator created successfully";
        state.arbitrators.push(action.payload.data);
      })
      .addCase(createArbitratorDetailsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateArbitratorDetailsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateArbitratorDetailsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Arbitrator updated successfully";

        const index = state.arbitrators.findIndex(
          (c) => c.arbitrator_ID === action.payload.data.arbitrator_ID,
        );

        if (index !== -1) {
          state.arbitrators[index] = action.payload.data;
        }
      })
      .addCase(updateArbitratorDetailsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(deleteArbitratorDetailsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteArbitratorDetailsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Arbitrator deleted successfully";

        state.arbitrators = state.arbitrators.filter(
          (c) => c.arbitratorI_D !== action.payload,
        );
      })
      .addCase(deleteArbitratorDetailsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(arbitratorResendCertificateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(arbitratorResendCertificateAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Certificate resent successfully";
      })
      .addCase(arbitratorResendCertificateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(arbitratorEmpanelRenewalStatusAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(arbitratorEmpanelRenewalStatusAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Renewal status updated successfully";
      })
      .addCase(arbitratorEmpanelRenewalStatusAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccess } = arbitratorDetailsSlice.actions;
export default arbitratorDetailsSlice.reducer;
